import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Frame from '../../Wrappers/Frame';
import { testWindow } from '../../Wrappers/MainWindow';
import ApplyMenu from './ApplyMenu';
import { offer } from '../../../services/api';
import { instagramRound } from '../../../helpers';
import * as applyOffersActions from '../../../redux/applyOffers';
import instagramIcon from '../../../svg/instagram-icon.svg';
import tiktokIcon from '../../../svg/tiktok-icon.svg';
import lockedIcon from '../../../svg/table-lock.svg';
import sortIcon from '../../../svg/sort-arrow.svg';
import noApplicants from '../../../svg/no-applicants.svg';
import './apply-offer.scss';

interface Props {
  match: any;
  location: any;
  applyOffers: any;
  fetchOffer: Function;
  goToApplicant: Function;
  changeFilter: Function;
  sortApplicants: Function;
  changePage: Function;
}

class ApplyOffer extends React.Component<Props> {
  // On mount, we fetch the offer that is being viewed and filter the attendees
  // to those who are "unreviewed", since this is the default view.
  componentDidMount() {
    let filter;
    if (this.props.location.state && this.props.location.state.filter) {
      filter = this.props.location.state.filter;
    }
    this.props.fetchOffer(this.props.match.params.offerId, filter);
  }

  // Change the filter view and update the attendees list to those who have the
  // currently selected status.
  changeStatusView(filter: ApplyOfferApplicantStatus) {
    this.props.changeFilter(this.props.applyOffers.offer.id, filter);
  }

  // Finalize the offer
  finalizeOffer() {
    if (moment(this.props.applyOffers.offer.deliberation_starts).isAfter()) return;

    offer
      .finalizeOffer(this.props.applyOffers.offer)
      .then(() => {
        window.location.replace(`${window.location.origin}/offers/active`);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getBanner(applicant) {
    let banner: any = null;

    if (applicant.is_cancelled) {
      banner = <div className="banner canceled">Canceled</div>;
    } else if (this.props.applyOffers.selectedFilter === 'selected') {
      if (applicant.is_locked) {
        banner = <div className="banner finalized">finalized</div>;
      } else {
        banner = <div className="banner selected">selected</div>;
      }
    }
    return banner;
  }

  bottomNav() {
    const selectedFilter = this.props.applyOffers.selectedFilter;

    if (selectedFilter === 'unreviewed')
      return (
        <div className="bottom-nav">
          <button onClick={() => this.changeStatusView('dismissed')}>{'<'} Dismissed</button>
          {this.pagination()}
          <button onClick={() => this.changeStatusView('liked')}>Liked {'>'}</button>
        </div>
      );
    if (selectedFilter === 'dismissed')
      return (
        <div className="bottom-nav">
          <div></div>
          {this.pagination()}
          <button onClick={() => this.changeStatusView('unreviewed')}>Unreviewed {'>'}</button>
        </div>
      );
    if (selectedFilter === 'liked')
      return (
        <div className="bottom-nav">
          <button onClick={() => this.changeStatusView('unreviewed')}>{'<'} Unreviewed</button>
          {this.pagination()}
          <button onClick={() => this.changeStatusView('selected')}>Selected {'>'}</button>
        </div>
      );
    if (selectedFilter === 'selected')
      return (
        <div className="bottom-nav">
          <button onClick={() => this.changeStatusView('liked')}>{'<'} Liked</button>
          {this.pagination()}
          <div></div>
        </div>
      );

    return <></>;
  }

  pagination() {
    const numOfPages = Math.ceil(
      this.props.applyOffers.applicants.length / this.props.applyOffers.pageSize
    );

    if (numOfPages < 2) return <></>;

    return (
      <div className="applicant-pagination">
        {Array.from({ length: numOfPages }).map((_, index) => (
          <button
            className={index + 1 === this.props.applyOffers.currentPage ? 'active' : ''}
            onClick={() => this.props.changePage({ currentPage: index + 1 })}
            key={index}
          >
            {index + 1}
          </button>
        ))}
      </div>
    );
  }

  // Builds the list of current applicants.
  listApplicantsTable() {
    const available_spots = this.props.applyOffers.offer.available_spots;
    const selectedBucket = this.props.applyOffers.buckets.find(
      (bucket) => bucket.name === 'selected'
    );
    const remainingSpots = available_spots - selectedBucket.count_of_models;

    const isDisabled = moment(this.props.applyOffers.offer.deliberation_starts).isAfter();

    const selectedFilter = this.props.applyOffers.selectedFilter;

    const paginatedApplicants = this.props.applyOffers.applicants.slice(
      (this.props.applyOffers.currentPage - 1) * this.props.applyOffers.pageSize,
      this.props.applyOffers.currentPage * this.props.applyOffers.pageSize
    );

    if (this.props.applyOffers.applicants.length === 0)
      return (
        <div key="empty" className="no-applicants">
          <img src={noApplicants}></img>
          <p className="text">No applicants here.</p>
        </div>
      );

    return (
      <>
        {selectedFilter === 'selected' ? (
          <div className="finalize-wrapper-table" key="finalize-wrapper">
            <div>
              <p className="remaining-spots">
                <span>{remainingSpots}</span> {remainingSpots === 1 ? 'spot' : 'spots'} remaining
              </p>
              <div className="content">
                <p className="max-number">
                  The maximum number of models you can finalize is {available_spots}.
                </p>
                <p className="final">Your selections are final.</p>
              </div>
            </div>
            <button disabled={isDisabled} onClick={() => this.finalizeOffer()}>
              FINALIZE
            </button>
          </div>
        ) : (
          <></>
        )}
        <div className="creators-table">
          <table className="creators-table__table">
            <thead>
              <tr>
                <th className="name-column">
                  <button
                    onClick={() =>
                      this.props.sortApplicants(
                        this.props.applyOffers.sorting === 'alphabetically'
                          ? 'alphabetically-reversed'
                          : 'alphabetically'
                      )
                    }
                    type="button"
                    className="table-sort-button"
                  >
                    {this.props.applyOffers.sorting.startsWith('alphabetically') && (
                      <img
                        src={sortIcon}
                        className={
                          this.props.applyOffers.sorting === 'alphabetically-reversed'
                            ? 'sort-icon-reverse'
                            : 'sort-icon'
                        }
                      />
                    )}
                    <span>Name</span>
                  </button>
                </th>

                <th>
                  <button
                    onClick={() =>
                      this.props.sortApplicants(
                        this.props.applyOffers.sorting === 'gender' ? 'gender-reversed' : 'gender'
                      )
                    }
                    type="button"
                    className="table-sort-button"
                  >
                    {this.props.applyOffers.sorting.startsWith('gender') && (
                      <img
                        src={sortIcon}
                        className={
                          this.props.applyOffers.sorting === 'gender-reversed'
                            ? 'sort-icon-reverse'
                            : 'sort-icon'
                        }
                      />
                    )}
                    <span>Gender</span>
                  </button>
                </th>

                <th>
                  <button
                    onClick={() =>
                      this.props.sortApplicants(
                        this.props.applyOffers.sorting === 'age-asc' ? 'age-desc' : 'age-asc'
                      )
                    }
                    type="button"
                    className="table-sort-button"
                  >
                    {this.props.applyOffers.sorting.startsWith('age') && (
                      <img
                        src={sortIcon}
                        className={
                          this.props.applyOffers.sorting === 'age-asc'
                            ? 'sort-icon-reverse'
                            : 'sort-icon'
                        }
                      />
                    )}
                    <span>Age</span>
                  </button>
                </th>

                <th className="categories-column">Categories</th>

                <th>
                  <button
                    onClick={() =>
                      this.props.sortApplicants(
                        this.props.applyOffers.sorting === 'ig-greatest'
                          ? 'ig-fewest'
                          : 'ig-greatest'
                      )
                    }
                    type="button"
                    className="table-sort-button"
                  >
                    {this.props.applyOffers.sorting.startsWith('ig') && (
                      <img
                        src={sortIcon}
                        className={
                          this.props.applyOffers.sorting === 'ig-fewest'
                            ? 'sort-icon-reverse'
                            : 'sort-icon'
                        }
                      />
                    )}
                    <span>IG</span>
                  </button>
                </th>

                <th>
                  <button
                    onClick={() =>
                      this.props.sortApplicants(
                        this.props.applyOffers.sorting === 'tiktok-greatest'
                          ? 'tiktok-fewest'
                          : 'tiktok-greatest'
                      )
                    }
                    type="button"
                    className="table-sort-button"
                  >
                    {this.props.applyOffers.sorting.startsWith('tiktok') && (
                      <img
                        src={sortIcon}
                        className={
                          this.props.applyOffers.sorting === 'tiktok-fewest'
                            ? 'sort-icon-reverse'
                            : 'sort-icon'
                        }
                      />
                    )}
                    <span>TikTok</span>
                  </button>
                </th>

                <th>
                  <button
                    onClick={() =>
                      this.props.sortApplicants(
                        this.props.applyOffers.sorting === 'location'
                          ? 'location-reversed'
                          : 'location'
                      )
                    }
                    type="button"
                    className="table-sort-button"
                  >
                    {this.props.applyOffers.sorting.startsWith('location') && (
                      <img
                        src={sortIcon}
                        className={
                          this.props.applyOffers.sorting === 'location-reversed'
                            ? 'sort-icon-reverse'
                            : 'sort-icon'
                        }
                      />
                    )}
                    <span>Location</span>
                  </button>
                </th>
                {selectedFilter === 'selected' && <th></th>}
              </tr>
            </thead>

            <tbody>
              {paginatedApplicants.map((applicant) => (
                <tr
                  key={applicant.id}
                  className={applicant.is_cancelled ? 'is-cancelled' : ''}
                  onClick={() =>
                    !applicant.is_cancelled
                      ? this.props.goToApplicant(
                          `/offer/apply/${this.props.match.params.offerId}/applicant/${applicant.id}`,
                          applicant
                        )
                      : null
                  }
                >
                  <td>
                    <div className="creators-table__creator-profile">
                      <img className="creators-table__avatar" src={applicant.model.avatar} />

                      <span className="creators-table__name">
                        {applicant.model.first_name + ' ' + applicant.model.last_name}
                      </span>
                    </div>
                  </td>

                  <td>{applicant.model.sex === 'f' ? 'Female' : 'Male'}</td>

                  <td>{applicant.model.stats?.age}</td>

                  <td>
                    {this.props.applyOffers.allClassificationsMapping
                      .filter((c) =>
                        applicant.model?.content_classifications.includes(c.classification)
                      )
                      .map((c) => c.name)
                      .join(', ')}
                  </td>

                  <td>
                    <div className="social-stat">
                      {applicant.model.instagram && (
                        <>
                          <img className="icon" src={instagramIcon}></img>
                          <span>
                            {instagramRound(applicant.model.instagram.number_of_followers)}
                          </span>
                        </>
                      )}
                    </div>
                  </td>

                  <td>
                    <div className="social-stat">
                      {applicant.model.tiktok && (
                        <>
                          <img className="icon" src={tiktokIcon} width={12} height={12}></img>
                          <span>{instagramRound(applicant.model.tiktok.number_of_followers)}</span>
                        </>
                      )}
                    </div>
                  </td>

                  <td>
                    <span className="creator-location">{applicant.model.location}</span>
                  </td>

                  {selectedFilter === 'selected' && applicant.is_locked && (
                    <td style={{ padding: '0 16px' }}>
                      <img src={lockedIcon} width={21} height={31} />
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }

  // Builds the list of current applicants.
  listApplicantsGrid() {
    const applicants: JSX.Element[] = [];

    const available_spots = this.props.applyOffers.offer.available_spots;
    const selectedBucket = this.props.applyOffers.buckets.find(
      (bucket) => bucket.name === 'selected'
    );
    const remainingSpots = available_spots - selectedBucket.count_of_models;

    const paginatedApplicants = this.props.applyOffers.applicants.slice(
      (this.props.applyOffers.currentPage - 1) * this.props.applyOffers.pageSize,
      this.props.applyOffers.currentPage * this.props.applyOffers.pageSize
    );

    if (this.props.applyOffers.applicants.length === 0) {
      applicants.push(
        <div key="empty" className="no-applicants">
          <img src={noApplicants}></img>
          <p className="text">No applicants here.</p>
        </div>
      );
    } else {
      if (this.props.applyOffers.selectedFilter === 'selected') {
        const isDisabled = moment(this.props.applyOffers.offer.deliberation_starts).isAfter();

        applicants.push(
          <div className="finalize-wrapper" key="finalize-wrapper">
            <div className="content">
              <p className="remaining-spots">
                {remainingSpots} {remainingSpots === 1 ? 'spot' : 'spots'} remaining
              </p>
              <p className="max-number">
                The maximum number of models you can finalize is {available_spots}
              </p>
              <p className="final">Your selections are final.</p>
            </div>
            <button disabled={isDisabled} onClick={() => this.finalizeOffer()}>
              FINALIZE
            </button>
          </div>
        );
      }

      for (let applicant of paginatedApplicants) {
        applicants.push(
          <div
            className={applicant.is_cancelled ? 'applicant canceled' : 'applicant'}
            onClick={() =>
              !applicant.is_cancelled
                ? this.props.goToApplicant(
                    `/offer/apply/${this.props.match.params.offerId}/applicant/${applicant.id}`,
                    applicant
                  )
                : null
            }
            key={applicant.model.name}
          >
            <div className="portrait-wrapper">
              {this.getBanner(applicant)}
              <img className="portrait" src={applicant.model.avatar}></img>
            </div>
            <h2>{applicant.model.first_name}</h2>
            <h2>{applicant.model.last_name}</h2>
            <div className="socials">
              {applicant.model.instagram ? (
                <p className="instagram-number">
                  <img className="icon" src={instagramIcon}></img>{' '}
                  {instagramRound(applicant.model.instagram.number_of_followers)}
                </p>
              ) : null}
              {applicant.model.instagram && applicant.model.tiktok && <div className="line"></div>}

              {applicant.model.tiktok ? (
                <p className="instagram-number">
                  <img className="icon" width={12} height={12} src={tiktokIcon}></img>{' '}
                  {instagramRound(applicant.model.tiktok.number_of_followers)}
                </p>
              ) : null}
            </div>
          </div>
        );
      }
    }

    return <>{applicants}</>;
  }

  render() {
    if (!this.props.applyOffers.offer || this.props.applyOffers.loading)
      return <div className="loading">Loading offer...</div>;

    if (this.props.applyOffers.offer.deliberation_status === 'finalized') {
      window.location.replace(`${window.location.origin}/offers/active`);
      return null;
    }

    const isJobOffer = this.props.applyOffers.offer.type === 'job';

    return (
      <Frame
        classes="apply-offer text-greyish-brown"
        title={
          this.props.applyOffers.offer.subtitle +
          ' > ' +
          this.props.applyOffers.selectedFilter.capitalize()
        }
        fullHeight={true}
      >
        <ApplyMenu buttonAction={this.changeStatusView.bind(this)} />

        {isJobOffer ? (
          <div className="sort-container">
            Sort applicants:{' '}
            <select
              onChange={(e) => this.props.sortApplicants(e.target.value)}
              name="sort-applicants"
              id="sort-applicants"
              value={this.props.applyOffers.sorting}
            >
              <option value="alphabetically">Alphabetically A-Z</option>
              <option value="alphabetically-reversed">Alphabetically Z-A</option>
              <option value="most-recent">Applied Most Recently</option>
              <option value="least-recent">Applied Least Recently</option>
              <option value="ig-greatest">IG Followers Greatest to Fewest</option>
              <option value="ig-fewest">IG Followers Fewest to Greatest</option>
            </select>
          </div>
        ) : (
          <></>
        )}

        {isJobOffer ? (
          <section className="applicants-list">
            {this.listApplicantsGrid()} {this.bottomNav()}
          </section>
        ) : (
          <>
            {this.listApplicantsTable()} {this.bottomNav()}
          </>
        )}
      </Frame>
    );
  }
}

const mapStateToProps = ({ applyOffers }) => ({ applyOffers });

export default connect(mapStateToProps, applyOffersActions)(testWindow(ApplyOffer, 'offers'));
